module.exports = __webpack_public_path__ + "img/Img18_211111_EdBt-3-1538.f0935a4d.jpg";